/** 漫画模块：圆角/壳层与 {@link ../create/createPanelTokens} 对齐 */

export function comicPanelRound(angular: boolean): string {
  return angular ? 'rounded-none' : 'rounded-2xl'
}

export function comicPanelRoundSm(angular: boolean): string {
  return angular ? 'rounded-none' : 'rounded-xl'
}

export function comicBookshelfShell(angular: boolean): string {
  return [
    'bg-[color-mix(in_srgb,var(--panel)_88%,var(--surface-muted))]',
    comicPanelRound(angular),
  ].join(' ')
}

export function comicSectionLabelClass(): string {
  return 'typo-lib-section font-semibold text-ink'
}

/** 漫画编辑区：除 input/textarea 外不可选中文字 */
export function comicEditorSelectClass(): string {
  return 'select-none [&_input]:select-text [&_textarea]:select-text'
}
